import React from 'react';
import isNil from 'lodash/isNil';
import {
  EligibilityOverviewBenefitRelatedEntity,
} from 'dtos/eligibilityOverviewBenefitRelatedEntity';
import Tag from 'core/components/Tag';
import Section from 'views/EMR/components/Eligibility/Overview/Section';
import {
  notEmptyString,
} from '@populateui/utils';

type Props = {
  relatedEntities: EligibilityOverviewBenefitRelatedEntity[];
};

export default function RelatedEntities({ relatedEntities }: Props) {
  return relatedEntities.length > 0 ? (
    <Section title="Benefit - related entities">
      <div className="grid grid-cols-4 gap-x-6 text-xs font-semibold text-gray-500 pb-2 border-b border-gray-200">
        <span>Entity</span>
        <span>Contact</span>
        <span>Address</span>
        <span>Associated benefits</span>
      </div>
      <div className="flex flex-col divide-y divide-gray-100">
        {relatedEntities.map((entity, index) => (
          <div key={entity?.entityName} className="grid grid-cols-4 gap-x-6 py-3 text-xs font-semibold text-gray-700">
            <span className="font-medium">{entity.entityName ?? '–'}</span>
            <span>{!isNil(entity.contact) ? entity.contact : '–'}</span>
            <span>{!isNil(entity.address) ? entity.address : '–'}</span>
            <div className="flex flex-col gap-1">
              {!isNil(entity.associatedServiceTypes) && entity.associatedServiceTypes.length > 0
                ? entity.associatedServiceTypes.map((service) => (
                  <div key={service.code} className="flex items-center gap-1.5">
                    {notEmptyString(service.code) && (
                      <Tag defaultColor="bg-gray-100 text-gray-700 cursor-default" className="!font-semibold">
                        {service.code}
                      </Tag>
                    )}
                    {notEmptyString(service.name) && <span className="font-medium text-gray-700">{service.name}</span>}
                  </div>
                ))
                : <span className="font-medium text-gray-700">–</span>}
            </div>
          </div>
        ))}
      </div>
    </Section>
  ) : null;
}
